import Orm from './Orm';

export default class Query {
    /**
     * The namespace used in store
     */
    static get namespace() {
        return Orm.namespace;
    }

    /**
     * Create a new Query instance.
     */
    constructor(model, store) {
        this.model = model;
        this.store = store;
        this.wheres = [];
        this.withs = [];
        this.order = null;
    }

    /**
     * Get query class.
     */
    self() {
        return this.constructor;
    }

    /**
     * Add a and where clause to the query.
     */
    where(field, value) {
        this.wheres.push({ field: field, value: value });
        return this;
    }

    /**
     * Set the relationships that should be loaded.
     */
    with(name) {
        this.withs.push(name);
        return this;
    }

    /**
     * Add an order to the query.
     */
    orderBy(field, direction = 'asc') {
        this.order = { field: field, direction: direction };
        return this;
    }

    /**
     * Returns all record of the query chain result.
     */
    get() {
        return this.select();
    }

    /**
     * Returns the first record of the query chain result.
     */
    first() {
        const records = this.select();

        if (records.length === 0) {
            return null;
        }

        return records[0];
    }

    /**
     * Returns the last record of the query chain result.
     */
    last() {
        const records = this.select();

        if (records.length === 0) {
            return null;
        }

        return records[records.length - 1];
    }

    /**
     * Find the record by the given id.
     */
    find(value) {
        const records = this.select();

        if (records.length === 0) {
            return null;
        }

        return records.find(record => record[this.model.primaryKey] == value);
    }

    /**
     * Returns all record of the query chain result. This method is alias
     * of the `get` method.
     */
    all() {
        return this.get();
    }

    /**
     * Process the query and filter data.
     */
    select() {
        // Get all record as an array and then start filtering it through.
        const ModelClass = this.model
        let records = this.store.state[this.self().namespace][ModelClass.entity].data
            .map(record => new ModelClass(record.$toJson(false)));

        // Let's filter the records at first by the where clauses.
        records = records.filter(record => {
            for (let i = 0; i < this.wheres.length; i++) {
                const condition = this.wheres[i];
                if (record[condition.field] != condition.value) {
                    return false;
                }
            }

            return true;
        });

        // Load relations
        records = records.map(record => {
            record.$load(this.withs);
            return record;
        });

        // Next, lets sort the data.
        if (this.order) {
            records = records.sort((a, b) => {
                if (a[this.order.field] < b[this.order.field]) {
                    return this.order.direction === 'desc' ? 1 : -1;
                }
                if (a[this.order.field] > b[this.order.field]) {
                    return this.order.direction === 'desc' ? -1 : 1;
                }
                return 0;
            });
        }

        return records;
    }
}
